module.exports = __webpack_public_path__ + "media/images/locus_logo-02a9453c9dbfa9e5a8fce93c990e492a.svg";